// extracted by mini-css-extract-plugin
module.exports = {"label":"_c78c6f7","search":"_84ad18b","inputWrapper":"_6d0e97f","input":"_9a5aa8d","iconWrapper":"_4ac514e","clearIcon":"_3f5c0f3","searchIcon":"_82565f0"};